<template>
  <div class="extras">
    <h1>Add Extras</h1>
    <p v-if="getAddonsStatus == 'success' && addons.length == 0">There are no extras available</p>
    <el-collapse v-model="activeSections">
      <el-collapse-item :title="category.description" :name="i" v-for="category, i in addons" v-if="isAddonsUpdated">
        <el-row :gutter="20" type="flex">
          <el-col :xs="24" :sm="12" :md="8" v-for="addon in category.price_keys.price_keys">
            <el-card shadow="never" :body-style="{ padding: '0px' }">
              <div slot="header">
                <h3>{{addon.conqueror_pro_price_key_name}}</h3>
              </div>
              <div class="image">
                <img :src="addon.picture_id" />
              </div>
              <div class="content">
                <div class="description">{{addon.description}}</div>
                <div class="price">
                  <i18n-n :value="+addon.value" format="currency"></i18n-n>
                </div>
                <el-form>
                  <el-input-number
                    :value="booking.options.addons[addon.id].qty"
                    @input="setAddon($event, addon)"
                    :min="0"
                    :max="30"
                    :size="formSize"
                  />
                </el-form>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import dateMixin from '../mixins/dateMixin'
import formMixin from '../mixins/formMixin'

export default {
  mixins: [dateMixin, formMixin],
  computed: {
    ...mapState({
      scenario: state => state.booking.options.scenario,
      booking: state => state.booking,
      order: state => state.order.order,
      //date: state => state.booking.options.date,
      //time: state => state.booking.options.time,
      addons: state => state.addons.all,
      getAddonsStatus: state => state.addons.status.getAddons
    }),
    ...mapGetters('booking', ['selectedAddons', 'selectedAddonsTotal'])
  },
  watch: {
    addons: 'addonsUpdated'
  },
  methods: {
    //...mapActions('booking', ['setAddon'])
    setAddon(qty, addon) {
      if (typeof qty != 'undefined') {
        this.$store.dispatch('booking/setAddon', { qty: qty, addon: addon })
      }
    },
    addonsUpdated() {
      let addons = []
      this.addons.forEach((category) => {
        addons.push(...category.price_keys.price_keys)
      })
      this.$store.dispatch('booking/initAddons', addons)
      this.isAddonsUpdated = true
    }
  },
  created() {
    const dt = this.parseDate(this.order.time)
    // Prevent jumping forward
    this.$store.commit('order/setOrderStatus', 'created')
    this.$store.dispatch('addons/getAddons', {
      date: this.dateForApi(dt),
      time: this.timeForApi(dt)
    })
  },
  data() {
    return {
      isAddonsUpdated: false,
      activeSections: [0]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../styles/mixins.scss";

  .el-col {
    padding-bottom: 1.5em;
  }

  .el-card {
    height: 100%;

    h3 {
      margin: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      font-size: 0.8em;
    }

    .image {
      @include fluid-aspect(16 9);
      img {
        display: block;
        object-fit: cover;
      }
    }
    .price {
      font-weight: bold;
      font-size: 1.2em;
      text-align: center;
    }
    .content {
      padding: 20px;
    }
    .description {
      height: 4em;
      font-size: 0.8em;
      text-align: center;
    }
    form {
      margin-top: 1em;
      text-align: center;
    }
  }
  .el-row--flex {
    flex-wrap: wrap;
  }
</style>
